
import Vue, { CreateElement, RenderContext, VNode } from "vue";

interface Props {
  filesCount: number;
  currentItem: number;
}

export default Vue.extend({
  name: "GalleryTotalItems",
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { filesCount, currentItem } = ctx.props;
    if (filesCount === 0) return h();
    const text = currentItem + 1 + "/" + filesCount;
    return h(
      "div",
      {
        class: { ...ctx.data.class, "px-2 py-1": true },
        directives: ctx.data.directives,
        staticClass: ctx.data.staticClass,
      },
      [text]
    );
  },
});
